import axios from 'axios';
import { useQuery } from '@tanstack/react-query';
import IAssignment from '@/components/interfaces/Assignment';
import { plato_api_section_progresses_path } from '@/modules/routes';
import { IClassroom } from '@/components/staffer/AssignmentsBasedGradesTable/types';
import useGradesTableStore from '@/components/staffer/AssignmentsBasedGradesTable/store/useGradesTableStore';
import { IExerciseProgress, PermittedAssignmentType } from './ReadingAssignmentsTable.types';
import { useAssignedItems } from './useAssignedItems';

export function progressQuery(classroom: IClassroom, exerciseIds: number[], assignmentType: PermittedAssignmentType) {
  return (
    axios.get<{ data: IExerciseProgress[] }>(plato_api_section_progresses_path({
      classroom_id: classroom.id,
      exercise_ids: exerciseIds,
      exercise_type: assignmentType,
    }))
  );
}

export function useProgresses(assignmentType: PermittedAssignmentType, assignment?: IAssignment) {
  const classroom = useGradesTableStore(state => state.classroom);
  const assignedItems = useAssignedItems(assignment);

  const exerciseIds = assignedItems
    .filter(assignedItem => assignedItem.assignment_type === assignmentType)
    .map(assignedItem => assignedItem.id);

  return useQuery({
    enabled: exerciseIds.length > 0 && !!assignmentType,
    placeholderData: [],
    queryFn: () => progressQuery(classroom, exerciseIds, assignmentType).then(res => res.data.data),
    queryKey: [classroom.id, assignmentType, exerciseIds.join(',')],
  });
}
